// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3ae13be","455":"48ef2205","977":"0ab1240b"}[chunkId] + ".chunk.js";
};